import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";


const API_ASSIGNMENT_PREVIEWS = `${TASK_SERVICE}/assignment-preview`;

export const assignmentPreviews = {
  getAll: async ({ filters, sort } = {}) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_PREVIEWS}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
    });
    return apiRequest(options);
  }, 
  get: async (id) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_PREVIEWS}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
}